module.exports = __webpack_public_path__ + "img/Bingo_Info_Game11.57f9e29a.png";